import Layout from '@/layout'

// GIMMATEK 只保留下載中心：會員管理、預約列表的匯出檔在這裡下載（CNCY-10766）
export const sheetExportCenterRoutes = [
  {
    path: '/data-explorer',
    component: Layout,
    name: 'SheetExportCenter',
    alwaysShow: true,
    isGroup: true,
    meta: {
      title: 'page.dataModule.title',
    },
    children: [
      {
        path: 'sheet-export-center',
        component: () => import('@/views/SheetExportCenter/SheetExportCenter.vue'),
        name: 'SheetExportCenter',
        meta: {
          title: 'page.downloadCenter.title',
          action: 'admin.sheetExportTask.page',
        },
      },
    ],
  },
]
